import { removeTrailingSlash } from '@/utils/removeTrailingSlash';

export function getLabradorApiUrl() {
  const apiBaseUrl = process.env.OCELOT_LABRADOR_API;
  if (!apiBaseUrl) throw new Error('Missing env: OCELOT_LABRADOR_API');
  return removeTrailingSlash(apiBaseUrl);
}
